export const REGISTER_COMPANY_LOADING = 'REGISTER_COMPANY_LOADING';
export const REGISTER_COMPANY_ERROR = 'REGISTER_COMPANY_ERROR';

export const REGISTER_COMPANY_FETCH_LICENSE_LOOKUP_SUCCESS = 'REGISTER_COMPANY_FETCH_LICENSE_LOOKUP_SUCCESS';
export const REGISTER_COMPANY_VALIDATE_COMPANY_TRADE_LICENSE_SUCCESS =
  'REGISTER_COMPANY_VALIDATE_COMPANY_TRADE_LICENSE_SUCCESS';
export const REGISTER_COMPANY_FETCH_APPLICATION_SUCCESS = 'REGISTER_COMPANY_FETCH_APPLICATION_SUCCESS';
export const REGISTER_COMPANY_FETCH_LOOKUPS_SUCCESS = 'REGISTER_COMPANY_FETCH_LOOKUPS_SUCCESS';
export const REGISTER_COMPANY_SET_COMPANY_DETAILS = 'REGISTER_COMPANY_SET_COMPANY_DETAILS';
export const REGISTER_COMPANY_CHANGE_WORKFLOW_STEP = 'REGISTER_COMPANY_CHANGE_WORKFLOW_STEP';
export const REGISTER_COMPANY_CHECKOUT_APPLICATION_SUCCESS = 'REGISTER_COMPANY_CHECKOUT_APPLICATION_SUCCESS';
export const REGISTER_COMPANY_CLEAR_LOADING = 'REGISTER_COMPANY_CLEAR_LOADING';
export const REGISTER_COMPANY_CLEAR_ERROR = 'REGISTER_COMPANY_CLEAR_ERROR';
export const REGISTER_COMPANY_CLEAR_FORM_ERROR = 'REGISTER_COMPANY_CLEAR_FORM_ERROR';
export const REGISTER_COMPANY_FORM_ERROR = 'REGISTER_COMPANY_FORM_ERROR';
export const REGISTER_COMPANY_CLEAR_TRADE_LICENSE_VALIDATION_RESPONSE =
  'REGISTER_COMPANY_CLEAR_TRADE_LICENSE_VALIDATION_RESPONSE';
export const REGISTER_COMPANY_CLEAR_APPLICATION_DATA = 'REGISTER_COMPANY_CLEAR_APPLICATION_DATA';

export const REGISTER_COMPANY_SET_DOCUMENT_SUCCESS = 'REGISTER_COMPANY_SET_DOCUMENT_SUCCESS';
export const REGISTER_COMPANY_DOWNLOAD_DOCUMENT_SUCCESS = 'REGISTER_COMPANY_DOWNLOAD_DOCUMENT_SUCCESS';
